export default __webpack_public_path__ + "static/media/10.257484d6.jpg";